// @flow

import { type Theme } from './types';

const theme: Theme = {
  button: {
    rounded: true,
    fontFamily: 'sansSerif',
    fontWeight: '400',
  },
  // @TODO: Change this font to the right font on new rebranding.
  fontFamily: {
    sansSerif: '"Noto Sans", "Open Sans", "OpenSans", "Helvetica Neue", Helvetica, Arial, sans-serif',
    display: '"Noto Sans", "Open Sans", "OpenSans", Arial, "Helvetica Neue", Helvetica, sans-serif',
  },
  fontSize: '14px',
  colors: {
    black: 'hsl(218, 44%, 32%)',
    blue: 'hsl(200, 81.43%, 46.47%)',
    green: l => `hsl(89, 46%, ${l}%)`,
    gray: l => `hsl(213, 16%, ${l}%)`,
    mediumGray: (s, l) => `hsl(217, ${s}%, ${l}%)`,
    secondaryGray: 'hsl(0, 0%, 20%)',
    terciaryGray: 'hsl(0, 0%, 96%)',
    primary: l => `hsl(201, 69%, ${l}%)`,
    secondary: l => `hsl(217, 41%, ${l}%)`,
    warning: l => `hsl(57, 93%, ${l}%)`,
    white: 'hsl(0, 0%, 100%)',
    offWhite: 'hsl(0, 0%, 98%)',
    error: l => `hsl(8, 56%, ${l}%)`,
    info: l => `hsl(201, 70%, ${l}%)`,
    new_primary: {
      [50]: '#E5EEFF',
      [100]: '#CCDCFF',
      [300]: '#6697FF',
      [500]: '#0051FF',
      [600]: '#0040CA',
      [700]: '#003199',
      [800]: '#0B3B68',
    },
    neutral: {
      white: '#FFFFFF',
      [100]: '#F1F3F6',
      [150]: '#E6E9EF',
      [200]: '#D4D9E3',
      [300]: '#AFB8CA',
      [400]: '#8B97B1',
      [500]: '#6C7993',
      [600]: '#515A6C',
      [700]: '#333947',
      [900]: '#121419',
    },
    feedback: {
      positive: {
        [100]: '#E4F6E8',
        [200]: '#B4E4BE',
        [500]: '#20A83E',
        [600]: '#1A8632',
      },
      warning: {
        [100]: '#FFF0DB',
        [200]: '#FFD599',
        [500]: '#FF9500',
        [600]: '#CC7700',
        [900]: '#804A00', // @TODO: Discuss with Bel this new color to check if it's appliable. If not, ask for suggestions for one that works with background #ffffff
      },
      error: {
        [100]: '#FAE8EA',
        [200]: '#F1BBC1',
        [500]: '#D21E32',
        [600]: '#A81828',
      },
    },
    wlc: {
      text: {
        muted: '#081F2B',
      },
      gray: {
        [20]: '#333333',
      },
    },
  },
  layout: {
    bordered: false,
    raised: true,
    hideEbanxHeader: false,
    hideMerchantLogo: false,
  },
  radius: '8px',
};

export default theme;
